import React, { useState, useRef } from 'react';
import { Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import * as Bixby from '$/core';
import InputBlock from '$/components/global/inputBlock';
import BixButton from '$/components/global/bixButton';
import Loading from '$/components/loading/Loading';
import './index.scss';
import { CloDealService } from '$/services';
import { toastError, toastSuccess } from '$/store/toast/actions';
import { AppState } from '$/store';
import { connect } from 'react-redux';

interface ICloUploadProps {
  currentClo?: Bixby.Models.CloDeal;
  isSuperAdmin?: boolean;
  dispatchToastSuccess: (message: string) => Promise<void>;
  dispatchToastError: (message: string) => Promise<void>;
}

const CloUpload: React.FC<ICloUploadProps> = ({ currentClo, dispatchToastError, dispatchToastSuccess }) => {
  const [fileName, setFileName] = useState('Choose a file or link');
  const [clofile, setCloFile] = useState({} as Blob);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadButton, setUploadButton] = useState(false);

  const formikRef = useRef<FormikProps<any>>(null);
  const initialClientDataSiteValues = {};
  const schema = Yup.object({});

  const handleFileUpload = (event: any) => {
    if (event.target.files[0]) {
      setCloFile(event.target.files[0]);
      setFileName(event.target.files[0].name);
      setUploadButton(true);
    } else {
      setCloFile({} as Blob);
      setFileName('Choose a file or link');
      setUploadButton(false);
    }
  };
  const submitFile = async () => {
    if (!currentClo?.id) return;

    try {
      setIsLoading(true);
      await CloDealService.uploadZipfile(currentClo.id, new File([clofile], fileName));
      dispatchToastSuccess(`Successfully uploaded zipfile`);
    } catch (ex) {
      dispatchToastError('Error loading file');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <section>
        <div className="client_clos">
          <section className="client_clo_upload">
            <Formik
              innerRef={formikRef}
              initialValues={initialClientDataSiteValues}
              validationSchema={schema}
              onSubmit={async () => {
                await submitFile();
              }}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="profile-input-container">
                  <div className="profile-input-column">
                    <InputBlock title="CLO Zip File">
                      <input
                        id="file-upload"
                        className="hidden_file_input"
                        type="file"
                        onChange={handleFileUpload}
                        multiple={false}
                      />
                      <label htmlFor="file-upload">{fileName}</label>
                    </InputBlock>
                    {isLoading && <Loading inline />}
                    {!isLoading && (
                      <BixButton type="submit" disabled={!uploadButton}>
                        Upload
                      </BixButton>
                    )}
                  </div>
                </form>
              )}></Formik>
          </section>
        </div>
      </section>
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    currentClo: state.cloDealState.currentCloDeal,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchToastSuccess: (message: string) => dispatch(toastSuccess(message)),
  dispatchToastError: (message: string) => dispatch(toastError(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CloUpload);
